<template>
  <v-dialog v-model="dialog" max-width="600">
    <ValidationObserver ref="transferForm" v-slot="{ invalid, passes }">
      <form
        rel="addCommentForm"
        class="flex flex-wrap justify-between sm:justify-center"
        @submit.prevent="passes(submit)"
      >
        <v-card>
          <v-card-title class="pa-7">Aplikovat promo kódy</v-card-title>
          <v-card-text class="pa-7">
            <v-row>
              <v-col cols="12" class="py-0 px-5">
                <GiftAutocomplete v-model="giftId" :items="gifts" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="gift.promoCodeApplyCount"
                  rules="required"
                  type="number"
                  outlined
                  dense
                  min="1"
                  label="Počet promo kódů k aplikování"
                  data-cy="name"
                />
              </v-col>
            </v-row>
            <v-row class="pb-6">
              <v-col cols="12" class="py-0 px-6">
                <div class="request-label">
                  Počet dostupných promo kódů:
                  <strong>
                    {{
                      gift && gift.promoCodeAvailableCount ? gift.promoCodeAvailableCount : '0'
                    }}</strong
                  >
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pl-7 pr-7 pb-7">
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :disabled="!canBeApplied"
              :loading="saving"
            >
              <template v-if="!gift.promoCodeApplyCount || gift.promoCodeApplyCount <= 0">
                Aplikovat promo kód
              </template>
              <template v-else-if="gift.promoCodeApplyCount === 1">
                Aplikovat {{ gift.promoCodeApplyCount }} promo kód
              </template>
              <template v-else-if="gift.promoCodeApplyCount > 1 && gift.promoCodeApplyCount < 5">
                Aplikovat {{ gift.promoCodeApplyCount }} promo kódy
              </template>
              <template v-else> Aplikovat {{ gift.promoCodeApplyCount }} promo kódů </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import GiftAutocomplete from '../forms/inputs/GiftAutocomplete'

export default {
  name: 'OrderPromoCodeAddDialog',
  components: { GiftAutocomplete },
  data() {
    return {
      giftId: null,
      gift: {},
      gifts: [],
      saving: false,
      loading: false,
      dialog: false,
    }
  },
  computed: {
    canBeApplied() {
      return (
        this.gift.promoCodeApplyCount !== 0 &&
        this.gift.promoCodeApplyCount >= 1 &&
        this.gift.promoCodeApplyCount &&
        this.gift.promoCodeAvailableCount >= this.gift.promoCodeApplyCount
      )
    },
  },
  watch: {
    giftId: {
      handler() {
        if (this.giftId) {
          this.loadGift()
        } else {
          this.gift = {}
        }
      },
    },
  },
  created() {
    const model = this
    this.$eventBus.$on('orderPromoCodeAddDialog', function (dialog) {
      model.giftId = null
      model.gift = {}
      model.gifts = []
      model.dialog = dialog
    })
  },
  methods: {
    ...mapActions({
      getGift: 'gift/getGift',
      createOrderPromoCode: 'order/createOrderPromoCode',
    }),
    submit() {
      this.$confirm('', {
        title: 'Opravdu aplikovat promo kódy?',
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'black',
      }).then((result) => {
        if (result) {
          this.createOrderPromoCode({
            id: this.$route.params.orderId,
            giftId: this.giftId,
            count: this.gift.promoCodeApplyCount,
          }).finally(() => {
            this.saving = false
            this.$refs.transferForm.reset()
            this.$emit('orderPromoCodeAdded')
            this.close()
          })
        }
      })
    },
    loadGift() {
      this.loading = true
      this.getGift(this.giftId)
        .then((response) => {
          this.gift = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    close() {
      this.dialog = false
    },
  },
}
</script>
